const NAME = "ASSETS_AND_DISCOUNTS_SCREEN_SELECTOR";

export default NAME;
